import { render, staticRenderFns } from "./findPassword.vue?vue&type=template&id=24734fa0&scoped=true"
import script from "./findPassword.vue?vue&type=script&lang=js"
export * from "./findPassword.vue?vue&type=script&lang=js"
import style0 from "./findPassword.vue?vue&type=style&index=0&id=24734fa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24734fa0",
  null
  
)

export default component.exports